import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor() { }

    async warningSwal(title: any, text: any, icon: any, isHtml: boolean = false) {
        return await Swal.fire({
            icon: icon,
            title: title,
            [isHtml ? 'html' : 'text']: text,
            // footer: '<a href>Why do I have this issue?</a>'
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Închide'
        });
    }

    warningSwalWithSupport() {

    }
}
